import { render, staticRenderFns } from "./action_info.vue?vue&type=template&id=410540cd&scoped=true&"
import script from "./action_info.vue?vue&type=script&lang=js&"
export * from "./action_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410540cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410540cd')) {
      api.createRecord('410540cd', component.options)
    } else {
      api.reload('410540cd', component.options)
    }
    module.hot.accept("./action_info.vue?vue&type=template&id=410540cd&scoped=true&", function () {
      api.rerender('410540cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/actions/modal/tabs/action_info.vue"
export default component.exports